import GamesScoreIcon from "../../icons/games/GamesScoreIcon";

export default function GamesCurrentScore({currentScore}) {
    // Used in

    // BUILD
    return (
        <div className={"bg-timerViolet w-[120px] min-w-[120px] h-[56px] min-h-[56px] " +
            "border-[1px] border-violetGrey rounded-[8px] " +
            "flex space-x-[8px] justify-center items-center"}>
            <GamesScoreIcon />
            <span className={"flex justify-start w-[48px] min-w-[48px] max-w-[48px] font-medium text-white text-[22px]"}>
                {currentScore}
            </span>
        </div>
    );
}